<template>
  <contract-profile-template-panel
      :dirty="dirty"
      :contract-profile-template-id="contractProfileTemplateId"
      @save="doSave"
      @dirty="markDirty"
      show-apply-button
      ref="panel">
    <template #toolbar-items>
      <v-toolbar-title class="with-divider">
        契約プロファイル
      </v-toolbar-title>
    </template>
  </contract-profile-template-panel>
</template>

<script>
import IoablePageMixin from "@/router/IoablePageMixin";
import ContractProfileTemplatePanel from "@/components/organisms/ContractProfileTemplatePanel.vue";
export default {
  name: "ContractProfileTemplate",
  components: {ContractProfileTemplatePanel},
  mixins: [IoablePageMixin],
  props: {
    contractProfileTemplateId: {
      type: String,
      required: true
    }
  },
  methods: {
    load() {
      return this.$refs.panel.load();
    },
    save() {
      return this.$refs.panel.save();
    }
  },
}
</script>

<style scoped>

</style>
